import React from 'react';
import {connect} from 'react-redux';
import PropTypes from 'prop-types';
import {Search} from "semantic-ui-react";
import {createRelatedBreakFromSelection, updateRelatedBreakSearchTextAction} from "./reducer";
import {extractResourceIdsWithPath, makeDBContentImageUrl} from "../../utils/DBUtils";

const RelatedBreakEditor = ({text, loading, updateText, select, results, canCreate}) => {
    const resultItems = results.map(result => ({
        title: result.title,
        description: result.description,
        image: makeDBContentImageUrl(result.cardImageId),
        permalink: result.permalink
    }));

    const placeholder = canCreate ? "Search for Breaks" : "Remove a related break to add another"

    return (
        <div className="related-break-editor">
            <p>If you specify Link Cards these setting will be ignored.</p>
            <Search
                loading={loading}
                fluid
                disabled={!canCreate}
                placeholder={placeholder}
                onResultSelect={(event, data) => select(data.result)}
                onSearchChange={({target}) => updateText(target.value)}
                results={resultItems}
                value={text}
            />
        </div>
    );
};

RelatedBreakEditor.propTypes = {
    text: PropTypes.string,
    loading: PropTypes.bool,
    results: PropTypes.array,
    updateText: PropTypes.func,
    select: PropTypes.func
};

RelatedBreakEditor.defaultProps = {
    text: '',
    loading: false,
    results: []
};

const mapState = ({relatedBreaks}, {formProxy}) => {
    const resource = formProxy.currentResource;
    const canCreate = (!resource.relatedBreaks || (resource.relatedBreaks && resource.relatedBreaks.length < 9));

    return {
        canCreate,
        text: relatedBreaks.searchText,
        loading: relatedBreaks.loading,
        results: relatedBreaks.searchResults,
    };
};

const mapDispatch = (dispatch, ownProps) => {
    const rootResource = ownProps.formProxy.baseResource["MASTER"];
    const resourcePath = ownProps.formProxy.resourcePath;

    let resourceIds = extractResourceIdsWithPath(
        rootResource,
        ownProps.formProxy.currentBaseResource,
        resourcePath
    );

    return {
        updateText: (text) => dispatch(updateRelatedBreakSearchTextAction({text})),
        select: (selection) => dispatch(createRelatedBreakFromSelection({
            selection,
            resourceIds,
            rootResource,
            resourcePath,
            fieldPath: ownProps.formProxy.fieldPath
        })),
    };
};

export default connect(mapState, mapDispatch)(RelatedBreakEditor);


// WEBPACK FOOTER //
// ./public/pages/RelatedBreakEditor/RelatedBreakEditor.jsx